import { reportsTypes } from '../reports';

export function pathNeedsTab(path) {
  if (path.indexOf(`/reports/${reportsTypes.CASH_REGISTER}/details`) >= 0) {
    return false;
  }
  return true;
}
